import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Card,
  Col,
  Collapse,
  Dropdown,
  Image,
  Menu,
  Modal,
  notification,
  Radio,
  Row,
  Skeleton,
  Tag,
  Timeline,
} from "antd";
import React, { useState } from "react";
import styled from "styled-components";
import { ORDER } from "../../graphql/queries/orders/order";
import { statusColor } from "./StatusOrder";
import moment from "moment";
import { IoIosArrowDown } from "react-icons/io";
import { BiErrorCircle } from "react-icons/bi";
import { BsFileCheck, BsFileMinus } from "react-icons/bs";
import { FaTruck } from "react-icons/fa";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { FcCancel } from "react-icons/fc";
import {
  ACCEPT_DESIGN,
  CANCEL_ORDER,
  RE_SUBMIT,
} from "../../graphql/mutation/orders/orderAction";
import Scrollbars from "react-custom-scrollbars";
import ShippingAddress from "./ShippingAddress";
import OrderDesignFile from "./OrderDesignFile";
import Customization from "./Customization";
const Container = styled.div`
  .ant-form-item {
    margin-bottom: 10px;
  }
  padding: 0 24px 24px;
  .ant-collapse-borderless {
    background-color: white;
  }
  .ant-collapse-header {
    background: white;
  }
  .ant-divider {
    margin: 15px 0;
  }
  .ant-timeline-item {
    padding-bottom: 10px;
  }
  .ant-timeline-item-head-blue {
    margin-top: 5px;
  }
  .ant-timeline-item-content {
    top: 0;
  }
`;

const OrderDetail = (props) => {
  const { id } = props.match.params;
  const currentUser = useSelector((state) => state.app.currentUser);
  const { data, loading, refetch } = useQuery(ORDER, { variables: { id: id } });
  const [cancelOrder, { loading: loadingCacel }] = useMutation(CANCEL_ORDER);
  const [reSubmit] = useMutation(RE_SUBMIT);
  const [acceptDesign, { loading: acceptLoading }] = useMutation(ACCEPT_DESIGN);
  const orderItem = data ? data.order : null;
  const [edit, setEdit] = useState(false);
  const [visible, setVisible] = useState(false);
  const handleClose = () => setVisible(false);

  const orderStatus = statusColor.find((el) => el.value === orderItem?.status);
  const availableMockup = orderItem?.product?.mockups?.find(
    (el) => el.variantId === orderItem?.productVariant?.id
  );

  const imageMockup = availableMockup
    ? availableMockup.image
    : orderItem?.product
    ? orderItem.product.mockups && orderItem.product?.mockups[0]?.image
    : null;

  const confirmCancel = () => {
    Modal.confirm({
      title: "Are you sure to cancel this order?",
      content: currentUser?.roles?.includes("Administrator") ? (
        <Radio.Group name="radiogroup" defaultValue={1}>
          <Radio value={1}>Cancel this order and cancel in store</Radio>
          <Radio value={2}>Cancel this order, without cancel in store</Radio>
          <Radio value={3}>
            {`Cancel this order &  related orders and cancel in store`}
          </Radio>
          <Radio value={4}>
            {`Cancel this order & related orders, without cancel in store`}
          </Radio>
        </Radio.Group>
      ) : null,
      onOk: () => {
        cancelOrder({
          variables: { id: orderItem.id },
        })
          .then(() => {
            refetch();
            notification.success({
              message: "The order cancelled successfully!",
            });
          })
          .catch((err) => notification.error({ message: err.message }));
      },
      width: 500,
      okButtonProps: { loading },
    });
  };

  const confirmModal = (type) => {
    Modal.confirm({
      title: `Are you sure to ${type} order${
        type !== "re-submit" ? " designs" : ""
      }?`,
      onOk: () => {
        if (["accept", "reject"]) {
          acceptDesign({
            variables: { orderId: orderItem.id, accept: type === "accept" },
          })
            .then(() => {
              notification.success({
                message: `The order designs has been ${
                  type + "ed"
                } successfully!`,
              });
              refetch();
            })
            .catch((err) => notification.error({ message: err.message }));
        } else {
          reSubmit({
            variables: { originID: orderItem.id },
          })
            .then(() => {
              notification.success({
                message: "The order re-submit successfully!",
              });
              refetch();
            })
            .catch((err) => notification.error({ message: err.message }));
        }
      },
      width: 500,
      okButtonProps: { loading: acceptLoading },
    });
  };
  const actionMenu = () => (
    <Menu
      onClick={({ key }) => {
        switch (key) {
          case "re-submit":
          case "reject":
          case "accept":
            return confirmModal(key);
          case "cancel":
            return confirmCancel();
          case "tracking":
            return setVisible(true);
          default:
            break;
        }
      }}
    >
      {/* <Menu.Item key="duplicate" icon={<HiDuplicate className="anticon" />}>
        Duplicate
      </Menu.Item> */}
      <Menu.Item
        hidden={
          orderItem.designs?.find((ds) => !ds.file) ||
          !["ReviewDesign"].includes(orderItem.status)
        }
        key="accept"
        icon={<BsFileCheck className="anticon" />}
      >
        Accept Design
      </Menu.Item>
      <Menu.Item
        hidden={
          orderItem.designs?.find((ds) => !ds.file) ||
          !["ReviewDesign"].includes(orderItem.status)
        }
        key="reject"
        icon={<BsFileMinus className="anticon" />}
        // style={{ color: "var(--error-color)" }}
      >
        Reject Design
      </Menu.Item>
      <Menu.Item
        hidden={!["InProduction", "Fulfilled"].includes(orderItem.status)}
        key="tracking"
        icon={<FaTruck className="anticon" />}
      >
        {isEmpty(orderItem?.tracking) ? "Add" : "Edit"} Tracking
      </Menu.Item>
      <Menu.Item
        className="delete-button-color"
        key="cancel"
        icon={<FcCancel className="anticon" />}
        // onClick={() => confirm()}
        hidden={["Cancelled", "InProduction", "Fulfilled"].includes(
          orderItem.status
        )}
      >
        Cancel
      </Menu.Item>
      {/* <Menu.Item
        hidden={
          !(
            ["Error"].includes(status) &&
            order?.productVariant?.productBase?.fulfillment?.type === "BuiltIn"
          )
        }
        key="re-submit"
        icon={<BiErrorCircle className="anticon" />}
      >
        Error
      </Menu.Item> */}
    </Menu>
  );

  if (loading) return <Skeleton />;

  return (
    <Container>
      <div className="flex space-between item-center">
        <div>
          <div className="mb-10 flex item-center">
            <span style={{ fontSize: 16, marginRight: 15 }}>
              Order: #{orderItem?.origin_id}
            </span>
            {orderStatus ? (
              <Tag className="mb-10" className={orderStatus.color}>
                {orderStatus.name}
              </Tag>
            ) : null}
          </div>
          <div className="mb-10">
            {moment(orderItem?.created_at).format("YYYY-MM-DD HH:mm:ss")}
          </div>
        </div>
        <div>
          {/* <Button
            type="link"
            onClick={() =>
              router.push("/orders/edit/[id]", `/orders/edit/${orderItem.id}`)
            }
          >
            Edit
          </Button> */}
          <Dropdown overlay={actionMenu()}>
            <Button type="link">
              More Actions <IoIosArrowDown className="anticon" />
            </Button>
          </Dropdown>
        </div>
      </div>
      <Row gutter={[24, 24]}>
        <Col span={16}>
          <Card>
            <div style={{ display: "grid", gridTemplateColumns: "120px auto" }}>
              <div style={{ width: 100 }}>
                <Image
                  style={{ backgroundColor: "#f5f5f5", objectFit: "contain" }}
                  width="105px"
                  height="105px"
                  preview={{
                    src: `${process.env.CDN_URL}/autoxauto/${imageMockup}`,
                  }}
                  src={`${process.env.CDN_URL}/300x300/${imageMockup}`}
                  fallback={`/no-preview.jpg`}
                />
              </div>
              <div className="grid">
                <h4>{orderItem?.product?.title}</h4>
                <span>
                  Product base: {orderItem?.productVariant?.productBase?.title}
                </span>
                <span>SKU: {orderItem?.productVariant?.sku}</span>
                {orderItem?.productVariant?.productBaseVariant?.attributes.map(
                  (attri, index) => (
                    <span key={index}>
                      {attri.name}: {attri.value}
                    </span>
                  )
                )}
              </div>
            </div>
            <Collapse
              className="mt-15"
              defaultActiveKey={["designs", "customization"]}
              expandIconPosition="right"
            >
              <Collapse.Panel key="designs" header="Designs">
                <OrderDesignFile refetch={refetch} orderItem={orderItem} />
              </Collapse.Panel>
              <Collapse.Panel key="customization" header="Customization">
                <Customization refetch={refetch} order={orderItem} />
              </Collapse.Panel>
            </Collapse>
          </Card>
          <Card className="mt-15" title="Timeline">
            <Scrollbars style={{ width: "auto", height: "300px" }}>
              <Timeline>
                {orderItem?.history?.length
                  ? orderItem?.history.map((item, index) => (
                      <Timeline.Item key={index}>
                        {item?.message} on{" "}
                        {moment(item?.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                        <>
                          <div style={{ color: "gray", fontSize: 12 }}>
                            {item.user
                              ? "By: " +
                                item.user.firstName +
                                " " +
                                item.user.lastName
                              : null}
                          </div>
                        </>
                      </Timeline.Item>
                    ))
                  : null}
              </Timeline>
            </Scrollbars>
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <ShippingAddress
              refetch={refetch}
              orderItem={orderItem}
              edit={edit}
              setEdit={setEdit}
              detail={true}
            />
          </Card>
          <Card className="mt-15">
            <h3 className="mb-10 ">Order summary</h3>
            <div className="mb-10 flex space-between">
              <span>
                <b>Order total:</b>
                <span className="ml-15">{orderItem?.quantity} item</span>
              </span>
              <span>{orderItem?.quantity * orderItem?.price} $</span>
            </div>
            <div className="flex space-between">
              <b>Order base cost:</b>
              <span>{orderItem?.baseCost} $</span>
            </div>
          </Card>
        </Col>
      </Row>
      <Modal
        className="no-padding-modal"
        title={isEmpty(orderItem?.tracking) ? "Add Tracking" : "Edit Tracking"}
        visible={visible}
        onCancel={handleClose}
        key={orderItem?.id}
        footer={
          <div>
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              type="primary"
              htmlType="submit"
              form="add-tracking"
              // loading={loadingAddTracking}
            >
              Save
            </Button>
          </div>
        }
      >
        {/* {formAddTracking} */}
      </Modal>
    </Container>
  );
};

export default OrderDetail;
